(function(){
  function nowLondonIso(){
    try{
      const fmt = new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/London',hour12:false,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'});
      const parts = Object.fromEntries(fmt.formatToParts(new Date()).map(p=>[p.type,p.value]));
      return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
    }catch(_){ return ''; }
  }
  /**
   * @param {string|undefined|null} s
   * @param {boolean} end
   */
  function norm(s,end){
    if(!s) return undefined;
    const stripped=String(s).trim().replace(' ','T').replace(/Z$/i,'').replace(/[+-]\d{2}:?\d{2}$/i,'');
    const parts=stripped.split('T'); const date=parts[0]||''; let time=parts[1]||(end?'23:59':'00:00');
    if(/^\d{2}:\d{2}:\d{2}$/.test(time)) time=time.slice(0,5);
    if(!/^\d{4}-\d{2}-\d{2}$/.test(date)) return undefined; if(!/^\d{2}:\d{2}$/.test(time)) return undefined;
    return `${date}T${time}`;
  }
  async function run(){
    try{
      // @ts-ignore
      const offers = Array.isArray(window.__influencerOffers)? window.__influencerOffers : [];
  /** @type {any[]} */
  const autoOffers = offers.filter(/** @param {any} o */ o=>o && o.autoAdd === true);
      if(!autoOffers.length) return;
      const cart = await fetch('/cart.js', { headers: { Accept:'application/json' } }).then(r=>r.json());
      const items = Array.isArray(cart && cart.items) ? cart.items : [];
      // Compute non-GWP subtotal (line_price) to ensure gifts don't count towards threshold
      // Exclude digital products (those that don't require shipping) and loyalty products from GWP threshold
      let nonGwpTotal = 0;
      for (let i = 0; i < items.length; i++) {
        const it = items[i] || {};
        const props = it.properties || {};
        const requiresShipping = it.requires_shipping !== false; // Default to true if undefined
        const isLoyaltyProduct = !!(props && props.__lion_sfp_id); // Loyalty products discounted to 0
        if (!(props && props._is_gwp === 'true') && requiresShipping && !isLoyaltyProduct) {
          const lp = Number(it.line_price || 0);
          if (!Number.isNaN(lp)) nonGwpTotal += lp;
        }
      }
      // stacking
  let disallowStack = true; try { const T = /** @type {any} */ ((typeof window !== 'undefined' && window && (/** @type {any} */(window)).Theme) ? (/** @type {any} */(window)).Theme : {}); disallowStack = !(T && T.flags && T.flags.allowGwpInfluencerStacking === true); } catch(_) {}
  if(disallowStack){ if(items.some((/** @type {any} */ it) => it && it.properties && it.properties._is_gwp === 'true')) return; }
  const inCartProductIds = items.map((/** @type {any} */ it)=>Number(it && it.product_id || 0)).filter((/** @type {number} */ n)=>!Number.isNaN(n) && n>0);
  const hasSub = items.some((/** @type {any} */ it) => it && (it.selling_plan_allocation || it.selling_plan_id || (it.properties && (it.properties.selling_plan || it.properties._rc))));
      // Get existing GWP groups in cart
      const existingGwpGroups = items.map((/** @type {any} */ it) => it && it.properties && it.properties._gwp_group ? String(it.properties._gwp_group) : '').filter(Boolean);
      const now = nowLondonIso();
      
      // Collect all qualifying offers to add
      const offersToAdd = [];
      const discountCodesToApply = [];
      
      for(const o of autoOffers){
        const key = `inf-auto-${(o.code||'').toLowerCase()}`;
        const gwpGroupIdentifier = `influencer:${String(o.code||'').toLowerCase()}`;
        // Skip if this specific GWP offer is already in cart
        if(existingGwpGroups.includes(gwpGroupIdentifier)) continue;
        if(sessionStorage.getItem(key)==='1') continue;
        // schedule
        const start = norm(o.scheduleStart,false); const end = norm(o.scheduleEnd,true);
        if((start && now < start) || (end && now > end) || (start && end && start > end)) continue;
        // eligibility
  if(Array.isArray(o.eligProducts) && o.eligProducts.length){
    const eligSkus = Array.isArray(o.eligSkus) && o.eligSkus.length ? o.eligSkus : [];
    if(eligSkus.length > 0){
      // Must match both product ID and SKU
      if(!items.some((/** @type {any} */ it) => { const pid = Number(it && it.product_id || 0); const sku = String(it && it.sku || '').trim().toUpperCase(); return pid > 0 && o.eligProducts.includes(pid) && sku && eligSkus.includes(sku); })) continue;
    } else {
      if(!o.eligProducts.some((/** @type {number} */ pid) => inCartProductIds.includes(Number(pid)))) continue;
    }
  }
  if(Array.isArray(o.eligCollectionProducts) && o.eligCollectionProducts.length){ if(!o.eligCollectionProducts.some((/** @type {number} */ pid) => inCartProductIds.includes(Number(pid)))) continue; }
        const gifts = Array.isArray(o.gifts) ? o.gifts : [];
        // threshold (cents) check - if set (>0) require nonGwpTotal >= threshold
        try {
          const threshold = Number(o.threshold || 0) || 0;
          if (threshold > 0 && nonGwpTotal < threshold) continue;
        } catch (_) {}
        if(!gifts.length) continue;
        
        // This offer qualifies - add to batch
        offersToAdd.push({ offer: o, key: key, gifts: gifts });
        
        // Collect discount code if present
        const chosen = hasSub ? (o.discountSubscription || o.discountOneTime || '') : (o.discountOneTime || '');
        if(chosen) discountCodesToApply.push(String(chosen));
      }
      
      // If no qualifying offers, exit
      if(!offersToAdd.length) return;
      
      // Add all qualifying gifts in batch
      try{
        const allGiftItems = [];
        for(const item of offersToAdd){
          const giftsForOffer = item.gifts.map((/** @type {number} */ id) => ({
            id: Number(id),
            quantity: 1,
            properties: { _is_gwp:'true', _gwp_group:`influencer:${String(item.offer.code||'').toLowerCase()}` }
          }));
          allGiftItems.push(...giftsForOffer);
        }
        
        await fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({ items: allGiftItems })
        });
        
        // Apply all discount codes if any
        if(discountCodesToApply.length){
          try{
            const c = await fetch('/cart.js', { headers:{Accept:'application/json'} }).then(r=>r.json());
            const existing = Array.isArray(c && c.discount_codes) ? c.discount_codes : [];
            const codes = existing.map((/** @type {{code:string}} */ d) => d && d.code ? String(d.code) : '').filter(Boolean);
            
            // Add new codes that aren't already present
            for(const newCode of discountCodesToApply){
              if(!codes.map((/** @type {string} */ x)=>x.toLowerCase()).includes(String(newCode).toLowerCase())){
                codes.push(String(newCode));
              }
            }
            
            const endpoint = (typeof Theme!=='undefined' && Theme.routes && Theme.routes.cart_update_url) ? Theme.routes.cart_update_url : '/cart/update.js';
            await fetch(endpoint, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
          }catch(_){/* no-op */}
        }
        
        // Mark all offers as processed
        for(const item of offersToAdd){
          sessionStorage.setItem(item.key,'1');
        }
        
        location.reload();
      }catch(_){/* no-op */}
    }catch(_){/* no-op */}
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', run, { once:true }); } else { run(); }
})();
